import { type FC } from 'react'
import classNames from 'classnames'
import { humanFileSize } from '../../common/util'
import { getFileIconClass } from '../DocumentFileBrowser/utils'
import { Button } from '../Button/Button'
import styles from './FileUpload.module.scss'

interface FileChipProps {
  fileName: string
  fileSize?: number
  disabled?: boolean
  ariaDescribedBy?: string
  onRemove: () => void
}

export const FileChip: FC<FileChipProps> = ({ fileName, fileSize, disabled, ariaDescribedBy, onRemove }) => (
  <div className='d-flex align-items-center zocks-gap-1 border zocks-border-color-gray-300 rounded-3 px-3 py-2'>
    <i className={classNames(styles.icon, 'bi', getFileIconClass(fileName))} aria-hidden='true' />
    <div className={classNames(styles.content, 'd-flex flex-column justify-content-center flex-grow-1 overflow-hidden')}>
      <span className='paragraph-small bold text-truncate'>{fileName}</span>
      {fileSize !== undefined ? <span className='paragraph-small zocks-text-gray-600'>{humanFileSize(fileSize)}</span> : null}
    </div>
    <Button
      type='button'
      variant='borderless'
      aria-label={`Remove ${fileName}`}
      aria-describedby={ariaDescribedBy}
      className='flex-shrink-0 p-2 bg-transparent'
      disabled={disabled}
      onClick={onRemove}
    >
      <i className='bi bi-x-lg' aria-hidden='true' />
    </Button>
  </div>
)
